/* eslint-disable */
export function getRules() {
  Office.context.document.settings.refreshAsync(function(asyncResult) {});
}
export function saveSettings(rules) {
  Office.context.document.settings.set("rules", rules);
  Office.context.document.settings.saveAsync(function(asyncResult) {});
}
/* eslint-enable */
